<button class="botao-primario disabled" [ngClass]="{'w-100': size==='100', 'disabled': isDisabled} "[disabled]="isDisabled">
    {{textButton}}
</button>

